import React, { type FC } from 'react';

import { Stack } from '@/components/layout';
import { Text } from '@/components/ui';
import { STRINGS } from '@/constants/strings';
import { MutatePlayerContactSectionMobile } from '@/features/player/components/mutate-player/mutate-player-contact-section/mutate-player-contact-section-mobile';
import { MutatePlayerContactSectionTablet } from '@/features/player/components/mutate-player/mutate-player-contact-section/mutate-player-contact-section-tablet';
import { createStyles, useScaling } from '@/hooks';
import { colors } from '@/theme/colors';

export type MutatePlayerContactSectionProps = {};

export const MutatePlayerContactSection: FC<MutatePlayerContactSectionProps> = () => {
  const { scale, isTablet } = useScaling();
  const styles = useStyles();

  return (
    <Stack gap={scale(12)} width="100%">
      <Text
        variant="Font Montserrat/Subtitle/Minimize 1 Bold 11px"
        fontWeight="800"
        style={styles.sectionTitle}>
        {STRINGS.player.mutatePlayer.contact.title}
      </Text>

      {isTablet ? <MutatePlayerContactSectionTablet /> : <MutatePlayerContactSectionMobile />}
    </Stack>
  );
};

const useStyles = createStyles(() => ({
  sectionTitle: {
    color: colors.Blue,
    textTransform: 'uppercase',
  },
}));
